import React from "react";
import { useTranslation } from "react-i18next";
import ReferenceListPage from "../components/ReferenceListPage";
import { productsAPI } from "../services/api";
import { loadProducts } from "../store/slices/referenceDataSlice";
import { PERMISSIONS } from "../utils/permissions";

const ProductsPage = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <ReferenceListPage
      title={t("sidebar.products")}
      api={productsAPI}
      reloadThunk={loadProducts}
      requiredPermission={PERMISSIONS.MANAGE_PRODUCTS}
      onNavigate={onNavigate}
      columns={[
        { field: "product_id", label: "#" },
        { field: "name_en", label: t("referencePages.nameEn") },
        { field: "name_ar", label: t("referencePages.nameAr") },
      ]}
      formFields={[
        {
          name: "name_en",
          label: t("referencePages.nameEn"),
          required: true,
        },
        {
          name: "name_ar",
          label: t("referencePages.nameAr"),
          required: true,
        },
      ]}
    />
  );
};

export default ProductsPage;
